import script from "./UsersMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersMenu.vue?vue&type=script&lang=ts&setup=true"

import "./UsersMenu.vue?vue&type=style&index=0&id=69ff87d9&lang=css"

const __exports__ = script;

export default __exports__